import { isPlatformBrowser } from '@angular/common';
import { Component } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Meta, SafeUrl, Title } from '@angular/platform-browser';
import * as _ from 'lodash';
import { FILE_ICON_TYPE, FileIconType, FileStoreType } from 'src/app/_enums/constant-types.enum';
import { FileStoreParams } from 'src/app/_models/file';
import { PortalData, PortalTherapeuticsData, Portal_Pubs_Details, Pub_files, PublicationsDataList, PublicationsSearchCriteria, PubsCatList, PubsProdList, PubsTherapeuticsList, } from 'src/app/_models/publications';
import { AlertifyService } from 'src/app/_services/alertify.service';
import { Page, PaginationService } from 'src/app/_services/pagination.service';
import { PublicationsService } from 'src/app/_services/publications.service';
import { UtilityService } from 'src/app/_services/utility.service';

@Component({
  selector: 'app-publications-details',
  standalone: false,
  // imports: [],
  templateUrl: './publications-details.component.html',
  styleUrl: './publications-details.component.css'
})
export class PublicationsDetailsComponent {

  PublicationsDataList: Array<PublicationsDataList> = []
  PubsTAList: Array<PortalTherapeuticsData> = [];
  PubsTADisplayList: Array<PortalTherapeuticsData> = [];
  taList: Array<PubsTherapeuticsList> = [];
  taDisplayList: Array<PubsTherapeuticsList> = [];
  prodList: Array<PubsProdList> = [];
  prodDisplayList: Array<PubsProdList> = [];
  catList: Array<PubsCatList> = [];
  portdata: PortalData;
  ConfigurationDataList: Array<Portal_Pubs_Details> = [];
  sortList: Array<Portal_Pubs_Details> = [];
  PublicationForm: UntypedFormGroup;
  _productid: string;
  ProductName: any;
  page: Page;

  // isChecked: boolean = false;
  has_search_criteria: boolean = false;
  is_search_selected: boolean = false;
  is_grid_selected: boolean = false;
  Is_Default: boolean = false;

  isSearchFieldEnable: boolean = false;
  isTPAenable: boolean = false;

  platformId: any;
  pdfDownloadURL: SafeUrl | null = null;

  fileStoreParams: FileStoreParams = {};
  isAsc = true;
  isDsc = false;
  headerKey: string;
  CurrentTags: any;

  constructor(private PublicationService: PublicationsService,
    public pagination: PaginationService,
    private alertfyService: AlertifyService,
    private metaTagService: Meta,
    private titleService: Title,
    private utilityService: UtilityService) {
    this.setSEOTags();
    this.page = this.pagination.setPagedRecords([], null);
    this.pagination.pageSize = 4;
    this.page.pager.itemsFrom = 0;
    this.page.pager.itemsTo = 0;
    this.page.pager.totalItems = 0;
  }

  ngOnInit(): void {
    this.setFormData();
    this.getPublicationsData();
  }

  setFormData() {
    this.PublicationForm = new UntypedFormGroup({
      Publication_Title: new UntypedFormControl(""),
      Therapeutic_Area_Name: new UntypedFormControl(""),
      Product_Name: new UntypedFormControl(""),
      Category_Name: new UntypedFormControl(""),
      Authors: new UntypedFormControl(""),
      Published_Date: new UntypedFormControl(""),
      Publication_URL: new UntypedFormControl(""),
      URL_Display_Name: new UntypedFormControl(""),
      SortBy: new UntypedFormControl("")
    });
  }

  PaginationSet() {
    this.page.pagedRecords = [];
    this.pagination.pageSize = 4;
    this.page.pager.itemsFrom = 0;
    this.page.pager.itemsTo = 0;
    this.page.pager.totalItems = 0;
  }

  getPublicationsData(isSearch: boolean = false) {
    let SearchCriteria: PublicationsSearchCriteria = {
      Publication_Title: this.PublicationForm.get('Publication_Title')?.value == null ? null : this.PublicationForm.get("Publication_Title")?.value,
      Therapeutic_Area_Id: this.PublicationForm.get('Therapeutic_Area_Name')?.value == null ? null : this.PublicationForm.get('Therapeutic_Area_Name')?.value,
      Product_Id: this.PublicationForm.get('Product_Name')?.value == null ? null : this.PublicationForm.get('Product_Name')?.value,
      Category_Id: this.PublicationForm.get('Category_Name')?.value == null ? null : this.PublicationForm.get('Category_Name')?.value,
      Authors: this.PublicationForm.get('Authors')?.value == null ? null : this.PublicationForm.get('Authors')?.value,
      Published_On: this.PublicationForm.get('Published_Date')?.value == null ? null : this.PublicationForm.get('Published_Date')?.value,
      Publication_URL: this.PublicationForm.get('Publication_URL')?.value == null ? null : this.PublicationForm.get('Publication_URL')?.value,
      URL_Display_Name: this.PublicationForm.get('URL_Display_Name')?.value == null ? null : this.PublicationForm.get('URL_Display_Name')?.value,
    };
    this.PublicationService.getPublicationsData(SearchCriteria).subscribe({
      next: (data) => {
        if (data) {
          if (!isSearch) {
            this.portdata = data
            this.has_search_criteria = this.portdata.Has_Search_Criteria ?? false;
            this.PublicationsDataList = this.portdata.GridDataList ?? [];
            this.ConfigurationDataList = this.portdata.Configuration ?? [];
            this.PrepareSearchListItems();
            this.prepareSortList();
          }
          this.PubsTAList = data.PortalTherapeuticWiseDataList ?? [];
          this.prepareListOrder();
        }
        else {
          this.PublicationsDataList = [];
          this.PubsTAList = [];
          this.ConfigurationDataList = [];
          this.PaginationSet();

        }
      },
      error: (err) => {
        console.log(err);

      }
    });
  }

  prepareListOrder(): void {
    this.PubsTAList = _.orderBy(this.PubsTAList, 'Therapeutic_Area_Name', 'asc');

    this.PubsTAList?.forEach((pub) => {
      pub.ProductsList = _.orderBy(pub.ProductsList, 'Product_Name', 'asc');
    });

    this.PubsTAList?.forEach((pub) => {
      pub.ProductsList?.forEach((prod: any) => {
        prod.CategoriesList = _.orderBy(prod.CategoriesList, 'Category_Name', 'desc');
      });
    });

    this.PubsTAList?.forEach((pub) => {
      pub.ProductsList?.forEach((prod: any) => {
        prod.CategoriesList?.forEach((cat: any) => {
          cat.PortalFilesList = _.orderBy(cat.PortalFilesList, 'Published_Date', 'desc');
        })
      });
    });

    this.setPagination();
  }

  PrepareSearchListItems(): void {
    this.taList = this.PublicationsDataList.map((pub) => {
      return {
        Therapeutic_Area_Id: pub.Therapeutic_Area_Id,
        Therapeutic_Area_Name: pub.Therapeutic_Area_Name
      }
    });
    this.taList = _.uniqBy(this.taList, 'Therapeutic_Area_Id');
    this.taDisplayList = this.taList;
    this.prodList = this.PublicationsDataList.map((pub) => {
      return {
        Product_Id: pub.Product_Id,
        Product_Name: pub.Product_Name,
        Therapeutic_Id: pub.Therapeutic_Area_Id
      }
    });
    this.prodList = _.uniqBy(this.prodList, 'Product_Id');
    this.prodDisplayList = this.prodList;

    this.catList = this.PublicationsDataList.map((pub) => {
      return {
        Category_Id: pub.Category_Id,
        Category_Name: pub.Category_Name
      }
    }).filter(x => x.Category_Id != undefined && x.Category_Id);

    this.catList = _.uniqBy(this.catList, 'Category_Id');
  }

  setPagination() {
    this.pagination.pageSize = 4
    this.page = this.pagination.setPagedRecords(this.PubsTAList, null);
  }

  get enableSearch() {
    let isEnable = false;
    let Therapeutic_Area_Id = this.PublicationForm.get("Publication_Title")?.value;
    let Product_Id = this.PublicationForm.get("Therapeutic_Area_Name")?.value;
    let Publication_Title = this.PublicationForm.get("Product_Name")?.value;
    let Published_On = this.PublicationForm.get("Category_Name")?.value;
    let Category_Id = this.PublicationForm.get("Authors")?.value;
    let Published_Date = this.PublicationForm.get("Published_Date")?.value;
    let Publication_URL = this.PublicationForm.get("Publication_URL")?.value;
    let URL_Display_Name = this.PublicationForm.get("URL_Display_Name")?.value;

    if (Therapeutic_Area_Id || Product_Id || Publication_Title || Published_On || Category_Id || Published_Date || Publication_URL || URL_Display_Name) {
      isEnable = true;
    }
    return isEnable;
  }

  clearSearch(): void {
    this.PublicationForm.patchValue({
      Publication_Title: "",
      Therapeutic_Area_Name: "",
      Product_Name: "",
      Category_Name: "",
      Authors: "",
      Published_Date: "",
      Publication_URL: "",
      URL_Display_Name: "",
      SortBy: ""
    });
    this.getPublicationsData(false);
  }

  prepareSortList() {
    let isTAField = this.ConfigurationDataList.find((x) => x.Field_Code == "THERAPEUTIC_AREA" && x.Is_Grid_selected);
    if(isTAField) {
      this.sortList.push(isTAField);
    }

    let isProdField = this.ConfigurationDataList.find((x) => x.Field_Code == "PRODUCT" && x.Is_Grid_selected);
    if(isProdField) {
      this.sortList.push(isProdField);
    }

    let isCatField = this.ConfigurationDataList.find((x) => x.Field_Code == "CATEGORY" && x.Is_Grid_selected);
    if(isCatField) {
      this.sortList.push(isCatField);
    }

    let isDateField = this.ConfigurationDataList.find((x) => x.Field_Code == "PUBLISHED_ON" && x.Is_Grid_selected);
    if(isDateField) {
      this.sortList.push(isDateField);
    }
  }

  //----------------------- Search Fields Enable Disable ------------------------------------------------------
  get displayTPAsearchvalues(): boolean {
    let isenable = false;
    let TPAData = this.ConfigurationDataList.filter((x) => x.Field_Name == "Therapeutic Area" && x.Is_Search_Selected)
    if (TPAData && TPAData.length > 0) {
      isenable = true;
    }
    return isenable;
  }

  get displayPRODsearchvalues(): boolean {
    let isenable = false;
    let PData = this.ConfigurationDataList.filter((x) => x.Field_Name == "Product" && x.Is_Search_Selected)
    if (PData && PData.length > 0) {
      isenable = true;
    }
    return isenable;
  }

  get displayCatsearchvalues(): boolean {
    let isenable = false;
    let catData = this.ConfigurationDataList.filter((x) => x.Field_Name == "Category" && x.Is_Search_Selected)
    if (catData && catData.length > 0) {
      isenable = true;
    }
    return isenable
  }

  get displayPTsearchvalues(): boolean {
    let isenable = false;
    let PUBTData = this.ConfigurationDataList.filter((x) => x.Field_Name == "Publication Title" && x.Is_Search_Selected)
    if (PUBTData && PUBTData.length > 0) {
      isenable = true;
    }
    return isenable
  }

  get displayAUTHsearchvalues(): boolean {
    let isenable = false;
    let AuthData = this.ConfigurationDataList.filter((x) => x.Field_Name == "Author(s)" && x.Is_Search_Selected)
    if (AuthData && AuthData.length > 0) {
      isenable = true;
    }
    return isenable
  }

  get displayPubDatasearchvalues(): boolean {
    let isenable = false;
    let PublicationDate = this.ConfigurationDataList.filter((x) => x.Field_Name == "Published Date" && x.Is_Search_Selected)
    if (PublicationDate && PublicationDate.length > 0) {
      isenable = true;
    }
    return isenable
  }

  get displayPUBURLsearchvalues(): boolean {
    let isenable = false;
    let PublicationURL = this.ConfigurationDataList.filter((x) => x.Field_Name == "Publication URL" && x.Is_Search_Selected)
    if (PublicationURL && PublicationURL.length > 0) {
      isenable = true;
    }
    return isenable
  }

  get displayURLNamesearchvalues(): boolean {
    let isenable = false;
    let PubFN = this.ConfigurationDataList.filter((x) => x.Field_Code == "URL_DISPLAY_NAME" && x.Is_Search_Selected)
    if (PubFN && PubFN.length > 0) {
      isenable = true;
    }
    return isenable
  }
get clearsearchenable():boolean{
  let EnableSC = false;

  if( this.has_search_criteria ){
    EnableSC = true;
  }
  return EnableSC
}
  //------------------------------ Grid fields Enable Disable ------------------------------------------------------------
  get displayTPAgridvalues(): boolean {
    let isenable = false;
    let TPAGRID = this.ConfigurationDataList.filter((x) => x.Field_Code == "THERAPEUTIC_AREA" && (x.Is_Grid_selected || x.Is_Default))
    if (TPAGRID && TPAGRID.length > 0) {
      isenable = true;
    }
    return isenable;
  }
  
  get displayProductgridvalues(): boolean {
    let isenable = false;
    let ProductGRID = this.ConfigurationDataList.filter((x) => x.Field_Code == "PRODUCT" && (x.Is_Grid_selected || x.Is_Default))
    if (ProductGRID && ProductGRID.length > 0) {
      isenable = true;
    }
    return isenable;
  }

  get displayCategorygridvalues(): boolean {
    let isenable = false;
    let Category = this.ConfigurationDataList.filter((x) => x.Field_Code == "CATEGORY" && (x.Is_Grid_selected || x.Is_Default))
    if (Category && Category.length > 0) {
      isenable = true;
    }
    return isenable;
  }

  get displayPubTitlegridvalues(): boolean {
    let isenable = false;
    let PubTitle = this.ConfigurationDataList.filter((x) => x.Field_Code == "PUBLICATION_TITLE" && (x.Is_Grid_selected || x.Is_Default))
    if (PubTitle && PubTitle.length > 0) {
      isenable = true;
    }
    return isenable;
  }

  get displayAuthgridvalues(): boolean {
    let isenable = false;
    let Authors = this.ConfigurationDataList.filter((x) => x.Field_Code == "AUTHORS" && (x.Is_Grid_selected || x.Is_Default))
    if (Authors && Authors.length > 0) {
      isenable = true;
    }
    return isenable;
  }

  get displayPubDategridvalues(): boolean {
    let isenable = false;
    let PubDate = this.ConfigurationDataList.filter((x) => x.Field_Code == "PUBLISHED_ON" && (x.Is_Grid_selected || x.Is_Default))
    if (PubDate && PubDate.length > 0) {
      isenable = true;
    }
    return isenable;
  }

  get displayPubURLgridvalues(): boolean {
    let isenable = false;
    let URL = this.ConfigurationDataList.filter((x) => x.Field_Code == "PUBLICATION_URL" && (x.Is_Grid_selected || x.Is_Default))
    if (URL && URL.length > 0) {
      isenable = true;
    }
    return isenable;
  }

  get displayURLDisplayNamegridvalues(): boolean {
    let isenable = false;
    let URL = this.ConfigurationDataList.filter((x) => x.Field_Code == "URL_DISPLAY_NAME" && (x.Is_Grid_selected || x.Is_Default))
    if (URL && URL.length > 0) {
      isenable = true;
    }
    return isenable;
  }

  get displayPubFileNamegridvalues(): boolean {
    let isenable = false;
    let FileName = this.ConfigurationDataList.filter((x) => x.Field_Code == "PUBLICATION_FILE_NAME" && (x.Is_Grid_selected || x.Is_Default))
    if (FileName && FileName.length > 0) {
      isenable = true;
    }
    return isenable;
  }

  get displayFileNamegridvalues(): boolean {
    let isenable = false;
    let FileName = this.ConfigurationDataList.filter((x) => x.Field_Code == "FILE_DISPLAY_NAME" && (x.Is_Grid_selected || x.Is_Default))
    if (FileName && FileName.length > 0) {
      isenable = true;
    }
    return isenable;
  }

  // ------------------------SORT BY-----------------------------------------------------------------------------------

  sortByOrder(order: boolean) {
    let sortValue = "";
    sortValue = this.PublicationForm.get('SortBy')?.value;

    if (sortValue == "THERAPEUTIC_AREA") {
      this.page.pagedRecords = _.orderBy(this.page.pagedRecords, 'Therapeutic_Area_Name', order ? 'asc' : 'desc');
      return;
    }

    if (sortValue == "PRODUCT") {
      this.page.pagedRecords?.forEach((pub) => {
        pub.ProductsList = _.orderBy(pub.ProductsList, 'Product_Name', order ? 'asc' : 'desc');
      });
      return;
    }

    if (sortValue == "CATEGORY") {
      this.page.pagedRecords?.forEach((pub) => {
        pub.ProductsList?.forEach((prod: any) => {
          prod.CategoriesList = _.orderBy(prod.CategoriesList, 'Category_Name', order ? 'asc' : 'desc');
        });
      });
    }

    if (sortValue == "PUBLISHED_ON") {
      this.page.pagedRecords?.forEach((pub) => {
        pub.ProductsList?.forEach((prod: any) => {
          prod.CategoriesList?.forEach((cat: any) => {
            cat.PortalFilesList = _.orderBy(cat.PortalFilesList, 'Published_Date', order ? 'asc' : 'desc');
          })
        });
      });
    }

  }

  enableSortIcon() {
    let isEnable = false;
    if (this.PublicationForm.controls['SortBy']?.value != "") {
      isEnable = true;
    }
    return isEnable;
  }

  //-----------------------------SORT BY ----------------------------------------------------------------------------

  download(file: Pub_files) {
    let fileType = this.getFileType(file.Pubs_File_Ext ?? '');

      try {
        if (fileType == FileIconType.HTML || fileType == FileIconType.IMAGE || fileType == FileIconType.PDF) {
            if (file.File_store_Id) {
              window.open(this.utilityService.getURL(file.File_store_Id, FileStoreType.FILE), '_blank');
            }
        }
        else {
          if (file.File_store_Id) {
            this.pdfDownloadURL = this.utilityService.downloadURL(file.File_store_Id, FileStoreType.FILE)
          }
        }
      } catch (exception) {
        this.alertfyService.errorBaner("Unknown Error - Cannot find File data.")
      }
  }


  getFileNameOnly(filenamewithextension: string): string {
    let onlyFileName: string = '';
    if (filenamewithextension) {
      onlyFileName = filenamewithextension.substr(0, filenamewithextension.lastIndexOf("."));
    }
    return onlyFileName;
  }

  getFileType(ext: string): string {
    let type: string = FILE_ICON_TYPE.OTHER;
    if (ext) {
      switch (ext) {
        case ".pdf":
          type = FILE_ICON_TYPE.PDF;
          break;
        case ".png":
        case ".jpg":
        case ".jpeg":
        case ".gif":
          type = FILE_ICON_TYPE.IMAGE;
          break;
        case ".mp4":
        case ".mp3":
        case ".mov":
        case ".wav":
        case ".webm":
          type = FILE_ICON_TYPE.VIDEO;
          break;
        default:
          type = FILE_ICON_TYPE.OTHER;
          break;
      }
    }
    return type;
  }

  ViewURL(therapeuticId: string, prodId: string, url: string, fileName: string = "", Profile_Id: string = "") {

    // if (!profile_id) {
    //   profile_id = localStorage.getItem('RT_ID') ?? '';
    // }
    this.PublicationService.ViewURL(therapeuticId, prodId, url, fileName, Profile_Id).subscribe((result: any) => {
      if (result.Status) {
       
      }
      else {
        this.alertfyService.errorBaner(result.Error);
      }
    });
  }

  ViewFile(therapeuticId: string, prodId: string,  fileName: string, Profile_Id: string = "") {
    this.PublicationService.ViewURL(therapeuticId, prodId,  fileName, Profile_Id).subscribe((result: any) => {
      if (result.Status) {
       
      }
      else {
        this.alertfyService.errorBaner(result.Error);
      }
    });
  }

  updateProdList(event: any): void {
    let theraId = event.target.value;
    if (theraId != "") {
      this.prodDisplayList = this.prodList.filter((prod) => prod.Therapeutic_Id == parseInt(theraId));
    }
    else {
      this.prodDisplayList = this.prodList;
    }
  }

  updateTheraList(event: any): void {
    let prodId = event.target.value;
    if (prodId != "") {
      let prod = this.prodDisplayList.find((prod) => prod.Product_Id == prodId);
      if (prod) {
        this.taDisplayList = this.taList.filter((thera) => thera.Therapeutic_Area_Id == prod.Therapeutic_Id);
      }
    }
    else {
      this.taDisplayList = this.taList;
    }
  }

  setSEOTags() {
    this.CurrentTags = this.utilityService.getCurrentPageTags("PUBS");
    let title = "";
    (this.CurrentTags == undefined || (this.CurrentTags?.Title == "")) ? title = "Publications" : title = this.CurrentTags.Title;
    this.titleService.setTitle(title);
    if (this.CurrentTags != null && this.CurrentTags != undefined) {
      this.metaTagService.updateTag({ name: 'description', content: this.CurrentTags.MetaDescription });
      this.metaTagService.updateTag({ name: 'title', content: this.CurrentTags.MetaTitle });
    }
    else {
      this.metaTagService.updateTag({ name: 'title', content: "" });
      this.metaTagService.updateTag({ name: 'description', content: "" });
    }
  }

}
